import React from 'react';
import { StatusBanner } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';

export const StatusBanners = ({
  hasStoreCodeBeenSetBefore = false,
  storeCodeSet = false,
  content: { statusBannerInfoNew, statusBannerInfoDone, statusBannerWarning }
}) => {
  if (hasStoreCodeBeenSetBefore && !storeCodeSet) {
    return (
      <StatusBanner.Warning title="">
        <StandardBody>{statusBannerWarning}</StandardBody>
      </StatusBanner.Warning>
    );
  }
  return (
    <StatusBanner.Information title="">
      <StandardBody>{storeCodeSet ? statusBannerInfoDone : statusBannerInfoNew}</StandardBody>
    </StatusBanner.Information>
  );
};

export default StatusBanners;
